const Spinner = () => {
    return (
      <div className="flex items-center justify-center h-screen z-50">
        <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-blue-500 border-solid z-50"></div>
      </div>
    );
  };
  
  export default Spinner;